goog.provide('yext.m4.confcode.adminconsole.ConsoleService');

/**
 * Maintains the state of the contents in the console for the Admin Console.
 *
 * @author Benjamin Leitner (bleitner@yext.com)
 */
yext.m4.confcode.adminconsole.ConsoleService = class {
  /**
   * @param {!Function} onChange  - Callback that's called whenever something is appended to the
   *                                console.
   */
  constructor(onChange) {
    this._state = [];
    this._onChange = onChange;
  }

  /**
   * Appends text on a new line in the console.
   *
   * @param {!string} text - The text to append
   */
  appendText(text) {
    this._state.push({
      type: 'info',
      text: text,
    });
    this._onChange();
  }

  /**
   * Appends an array of text, each on a new line, in the console.
   *
   * @param {!Array<string>} textArr - The text to append
   */
  appendTextArray(textArr) {
    textArr.forEach(text => {
      this._state.push({
        type: 'info',
        text: text,
      });
    });
    this._onChange();
  }

  /**
   * Appends errors, each on a new line, in the console.
   *
   * @param {!Array<!yext.m4.errors.DiagnosticData.Diagnostic>} errors - The errors to append
   */
  appendErrors(errors) {
    errors.forEach(error => {
      this._state.push({
        type: 'error',
        meta: this._buildDiagnosticMeta(error),
        text: error.message,
      });
    });
    this._onChange();
  }

  /**
   * Appends warnings, each on a new line, in the console.
   *
   * @param {!Array<!yext.m4.errors.DiagnosticData.Diagnostic>} warnings - The warnings to append
   */
  appendWarnings(warnings) {
    warnings.forEach(warning => {
      this._state.push({
        type: 'warning',
        meta: this._buildDiagnosticMeta(warning),
        text: warning.message,
      });
    });
    this._onChange();
  }

  /**
   * Returns the current state of the console output
   *
   * @returns {!Array}
   */
  getConsoleOutput() {
    return this._state;
  }

  /**
   * Converts the diagnostic object to the text to be rendered.
   *
   * @param {!yext.m4.errors.DiagnosticData.Diagnostic} diagnostic
   * @return {undefined|!string}
   * @private
   */
  _buildDiagnosticMeta(diagnostic) {
    if (diagnostic.fileLocation) {
      const fileLocation = diagnostic.fileLocation;
      return `${fileLocation.filePath}:${fileLocation.coordinate.row}:${fileLocation.coordinate.column}: `;
    }
  }
};
